import { render, staticRenderFns } from "./companyTree.vue?vue&type=template&id=3583a8fc&scoped=true&"
import script from "./companyTree.vue?vue&type=script&lang=js&"
export * from "./companyTree.vue?vue&type=script&lang=js&"
import style0 from "./companyTree.vue?vue&type=style&index=0&id=3583a8fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3583a8fc",
  null
  
)

export default component.exports